import _ from 'lodash';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { ChangeEMail } from 'app/signup/features/data/data.actions';
import { selectUser, selectUserError } from 'app/signup/features/data/data.selectors';
import { ERRORS } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public error$ = this.store.pipe(
    select(selectUserError)
  );

  public user$ = this.store.pipe(
    select(selectUser)
  );

  public form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private store: Store,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.error$.pipe(
      filter(error => !_.isNull(error)),
      filter(error => !_.isEqual(error, false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.form.get('email').setErrors({ unique: true });
    });

    this.user$.pipe(
      filter(user => !_.isNull(user)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(user => {
      this.form.get('email').setValue(user.email);
    });
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);

    const { initialState: { action, callback } } = dialog;
    if (value) {
      if (action) {
        this.store.dispatch(action);
      }
      callback(value);
    }
  }

  confirm(dialog, value) {
    const { form } = this;
    if (form.invalid) {
      return form.markAllAsTouched();
    }

    this.store.dispatch({
      type: ChangeEMail.type,
      payload: form.value
    });

    this.error$.pipe(
      filter(error => _.isNull(error)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.close(dialog, value);
    });
  }

  getEMailError() {
    const { form } = this;
    const email = form.get('email');

    if (!email.touched) return '';

    if(email.hasError('required')) {
      return 'Please provide valid email id';
    }

    if (email.hasError('unique')) {
      return ERRORS.UserAlreadyExist;
    }

    return '';
  }
}
